module.exports = __webpack_public_path__ + "img/2017_0.d2e77cbd.webp";